import { FC, ChangeEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
    updateFilter,
    chainFreeSelector,
    priceReducedSelector,
    underOfferOrSoldSelector
} from '@zoopla/redux-reducer-filters';
import { SometimesInlineFiltersCheckBox } from './Filters.styles';

export const SelectPropertyStatus: FC = () => {
    const reduxDispatch = useDispatch();

    const onChainFreeChange = (evt: ChangeEvent<HTMLInputElement>) => {
        reduxDispatch(updateFilter('chainFree', evt.currentTarget.checked));
    };

    const onPriceReducedChange = (evt: ChangeEvent<HTMLInputElement>) => {
        reduxDispatch(updateFilter('priceReduced', evt.currentTarget.checked));
    };

    const onUnderOfferOrSoldChange = (evt: ChangeEvent<HTMLInputElement>) => {
        reduxDispatch(
            updateFilter('underOfferOrSold', evt.currentTarget.checked)
        );
    };

    const { label: chainFreeLabel, selectedValue: chainFreeSelectedValue } =
        useSelector(chainFreeSelector);

    const {
        label: priceReducedLabel,
        selectedValue: priceReducedSelectedValue
    } = useSelector(priceReducedSelector);

    const {
        label: underOfferOrSoldLabel,
        selectedValue: underOfferOrSoldSelectedValue
    } = useSelector(underOfferOrSoldSelector);

    return (
        <>
            <SometimesInlineFiltersCheckBox
                id={'chainFree'}
                key={'chainFree'}
                onChange={onChainFreeChange}
                label={chainFreeLabel}
                checked={chainFreeSelectedValue}
            />
            <SometimesInlineFiltersCheckBox
                id={'priceReduced'}
                key={'priceReduced'}
                onChange={onPriceReducedChange}
                label={priceReducedLabel}
                checked={priceReducedSelectedValue}
            />
            <SometimesInlineFiltersCheckBox
                id={'underOfferOrSold'}
                key={'underOfferOrSold'}
                onChange={onUnderOfferOrSoldChange}
                label={underOfferOrSoldLabel}
                checked={underOfferOrSoldSelectedValue}
            />
        </>
    );
};
